import React from 'react';
import { exportRows, csvFilename } from './lib/csv';

/**
 * "Export CSV" for one panel's rows (spec v2 §7).
 *
 * Lives inside the panel it belongs to rather than in a page-level export menu — §3 puts
 * every specialist affordance "inside the panel it belongs to rather than in a separate
 * place", and a page-level menu would have to ask which panel it meant.
 *
 * Renders nothing when there is nothing to export. A download button that produces a
 * file with a header row and no data is a control that lies about having data.
 *
 * `name` is the panel's own title and is what names the file; `panelKey` is only the
 * test hook and the fallback. See `csvFilename` for why the key must not reach a
 * filename.
 */
const CsvButton = ({ panelKey, name, columns, rows, range, label = 'Export CSV' }) => {
  const list = Array.isArray(rows) ? rows : [];
  if (list.length === 0) return null;

  return (
    <button
      type="button"
      data-testid={`csv-${panelKey}`}
      onClick={() => exportRows(columns, list, csvFilename(name || panelKey, range))}
      className="text-sm font-medium text-[#32B1FF] hover:underline"
    >
      {label}
    </button>
  );
};

export default CsvButton;
